<template>
  <div class="all">
    <div class="header">
      <el-form inline size="small">
        <el-form-item>
          <el-select v-model="prjID" filterable size="small" placeholder="请选择项目" @change="getTableData(1)">
            <el-option v-for="(item, index) in prjList" :key="index" :label="item.prjName" :value="item.prjId" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="search" size="small" clearable placeholder="请输入检索的关键字" prefix-icon="el-icon-search"
            @keyup.native.enter="getTableData(1)" />
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="formdata.startTime" size="small" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
            placeholder="开始时间" />
          <span style="vertical-align:top">——</span>
          <el-date-picker v-model="formdata.endTime" size="small" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="getTableData(1)">
            检索
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="mid">
      <el-table key="1" v-loading="loading" :data="comTable" :row-style="rowStyle" :header-cell-style="headerStyle"
        element-loading-text="数据加载中" height="100%">
        <template slot="empty">
          <img :src="zanwu" alt="">
          <p style="font-size:16px;color:#000;margin-top:36px">
            暂无数据
          </p>
        </template>
        <el-table-column type="index" width="80" label="序号" align="center" />
        <el-table-column label="操作用户" min-width="180" prop="name" />
        <el-table-column label="操作时间" min-width="200" prop="createDate" />
        <el-table-column label="操作内容" show-overflow-tooltip prop="content" min-width="200px" />
        <el-table-column label="登录IP" align="left" prop="ip" min-width="200px" />
      </el-table>
    </div>
    <div class="footer">
      <page :page="page" @handleSizeChange="handleSizeChange" @handleCurrentChange="getTableData"></page>
    </div>
  </div>
</template>

<script>
import systemPersonService from "@/CommonDP/service/enterprisePerson-service";
import project from "@/CommonDP/service/integratedModel-service";
import page from "@/CommonDP/components/paging";
import { mapState } from "vuex";
export default {
  components: { page },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      loading: false,
      formdata: {
        startTime: "",
        endTime: ""
      },
      search: "",
      prjID: "",
      prjList: [],
      comTable: [],

      page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  created() {
    this.getProjectList(1);
  },
  methods: {
    async getProjectList() {
      this.loading = true;
      if (this.enterpriseId) {
        const params = {
          enterpriseId: this.enterpriseId,
          prjName: "",
          prjCode: "",
          prjType: "",
          prjLevel: ""
        };
        const result = await project.queryPrj(params);
        if (result.result === "0") {
          this.loading = false;
          this.prjList = result.data;
          if (!!result.data && result.data.length > 0) {
            this.prjID = result.data[0].prjId;
            this.getTableData(1);
          }
        }
      }
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getTableData(1);
    },
    async getTableData(index) {
      this.loading = true;
      const {
        search,
        page: { pageSize }
      } = this;
      const params = {
        content: search,
        startTime: this.formdata.startTime,
        endTime: this.formdata.endTime,
        pageSize,
        pageNum: index,
        prjId: this.prjID
      };
      const { data, totalCount, pageNum } = await systemPersonService.projectList(params);
      this.page.totalCount = totalCount;
      this.page.pageNum = pageNum;
      this.comTable = data;
      this.loading = false;
    },
    rowStyle() {
      return "height:60px";
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9";
    }
  }
};
</script>

<style lang="scss" scoped>
.all {
  height: 100%;
  position: relative;
  .mid {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    bottom: calc(32px + var(--middle-space) * 2);
  }
  .footer {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: var(--middle-space) 0;
  }
}
</style>
